import { useEffect, useState } from 'react';
import { LiffApp } from './LiffApp';
import { liff } from '@line/liff';
import { ChakraProvider, Spinner, Center, useDisclosure } from '@chakra-ui/react';
import { theme } from './theme';
import { HelmetProvider } from 'react-helmet-async';
import Cookies from 'js-cookie';
import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { Analytics } from "@vercel/analytics/react"

const OnboardingModal = React.lazy(() => import('./components/OnboardingModal'));

export const AppWrapper: React.FC = () => {
  const [, setIsLiff] = useState<boolean>(false);
  const [isLiffLoading, setIsLiffLoading] = useState<boolean>(true);
  const { isOpen: isOnboardingOpen, onOpen: onOpenOnboarding, onClose: onCloseOnboarding } = useDisclosure();

  useEffect(() => {
    const hasSeenOnboarding = Cookies.get('hasSeenOnboarding');
    const isConnected = Cookies.get('isConnected');

    if (!hasSeenOnboarding && !isConnected) {
      onOpenOnboarding();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const initializeLiff = async () => {
      try {
        const liffId = process.env.REACT_APP_LIFF_ID || '2006689873-VxpWRda5';
        await liff.init({ liffId });
        setIsLiff(liff.isInClient());
      } catch (err) {
        console.error('LIFF initialization failed', err);
      } finally {
        setIsLiffLoading(false);
      }
    };

    initializeLiff();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ChakraProvider theme={theme}>
        <HelmetProvider>
          <React.Suspense fallback={null}>
            <OnboardingModal isOpen={isOnboardingOpen} onClose={onCloseOnboarding} />
          </React.Suspense>
          {isLiffLoading ? (
            <Center h="100vh">
              <Spinner size="xl" color="opensea.500" />
            </Center>
          ) : (
            <BrowserRouter>
              <LiffApp liff={liff} />
            </BrowserRouter>
          )}
          <Analytics />
        </HelmetProvider>
      </ChakraProvider>
    </I18nextProvider>
  );
};

export default AppWrapper;